/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idOportunidade: string;
  IdLeadCorretor: string;
}

export function useVincularLead() {
  const postData = async (props: Props) => {
    const VINCULAR_LEAD = `${backofficeEnviroment}/common/oportunidades-lead/vincular-lead/v1`;
    const { data } = await instance.post(VINCULAR_LEAD, {
      idOportunidade365: props.idOportunidade,
      Id365: props.IdLeadCorretor,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("Proposta vinculada com sucesso!");
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao vincular proposta. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
